<template>
  <div class="flex animate-pulse flex-col px-3">
    <div class="mb-2 flex gap-2 overflow-hidden" />
    <div class="h-[320px] w-full rounded-2xl bg-secondary md:h-[516px]" />
  </div>
</template>

<script lang="ts" setup></script>
